<template>
  <div class="sbd-avatar" :class="'ivu-avatar-'+shape" :style="{ width:width + 'px',height:height + 'px',lineHeight:height + 'px'}">
    <img :src="url ? url : defaultUrl"  width="100%" :class="{'sbd-height-auto':isAuto}"/>
  </div>
</template>

<script>
  export default {
    name: "AvatarImg",
    data(){
      return{
        defaultUrl:require('../../assets/svg/avatar.svg')
      }
    },
    props:{
      url:{
        default:this.defaultUrl
      },
      shape:{
        type:String,
        default: 'circle'
      },
      width:{
        type: String,
        default:'64'
      },
      height:{
        type:String,
        default:'64'
      },
      isAuto:{
        type:Boolean,
        default:false
      }
    },
    methods:{

    }
  }
</script>

<style scoped>
  .sbd-avatar{ width: 64px;height: 64px;line-height: 64px;display: inline-block;text-align: center;background: #ccc;color: #fff;white-space: nowrap;position: relative;overflow: hidden;vertical-align: middle;border-radius: 50%; }
  .sbd-avatar.ivu-avatar-circle{ border-radius: 50%; }
  .sbd-avatar.ivu-avatar-square{ border-radius: 8px; }
  .sbd-height-auto{ height:100% }
</style>



// WEBPACK FOOTER //
// src/model/avatar/avatar.vue